import { css } from '@inter-ikea-kompis/web-component';
import AddToListLayoutEnum from '../../enums/AddToListLayoutEnum.js';
export default class AddToListStyle {
    static getStyle(options) {
        if (options.addToListLayout === AddToListLayoutEnum.text) {
            return css `
				/* This reflects how Skapa styles their fluid buttons. */
				:host {
					display: block;
					width: 100%;
				}
			`;
        }
        return '';
    }
}
//# sourceMappingURL=AddToListStyle.js.map